import { IRSAgentCard } from '@/common/containers/Dashboard/AI/IRSAgentCard/IRSAgentCard';
import { AlertOffboardingMeal } from '@/common/containers/Dashboard/Home/AlertOffboardingMeal/AlertOffboardingMeal';
import { useFeatures } from '@/common/integrations/feature-flag/feature-flag.hooks';

export function useGetPTHomeAlerts() {
  return <AlertOffboardingMeal />;
}

export function useGetPTHomeSecondaryActions() {
  const {
    features: { ff_employee_coverflex_ai_irs },
  } = useFeatures();

  return ff_employee_coverflex_ai_irs && <IRSAgentCard />;
}
